import React, { useState, useEffect } from 'react';
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useAppId } from "../context/AppIdContext";
import Header from '../component/header';
import '../style/boothPramukh.css'

const BASE_URL = process.env.REACT_APP_BASE_URL;

const BoothPramukh = () => {
    const navigate = useNavigate();
    const { appId, language, userId, userName } = useAppId();
    const lang = language || 'en';

    // --- State ---
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    // --- Mobile Search State ---
    const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);

    // --- Create Pramukh Modal State ---
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [createFormData, setCreateFormData] = useState({
        booth_no: '',
        name: '',
        mobile_no: ''
    });
    const [createMobileError, setCreateMobileError] = useState("");

    // --- Edit Modal State ---
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editFormData, setEditFormData] = useState({
        user_id: '',
        name: '',
        mobile_no: '',
        user_type: ''
    });
    const [editMobileError, setEditMobileError] = useState("");

    // --- Profile Detail Modal State ---
    const [selectedUser, setSelectedUser] = useState(null);

    // Generate WhatsApp message in Gujarati for Pramukh
    const generateWhatsAppMessage = (user) => {
        const loginUserName = userName || 'Admin';
        return `નમસ્તે ${user}, ${loginUserName} એ તમને બૂથ પ્રમુખની જવાબદારી સોંપેલી છે.`;
    };

    // Generate SMS message in Gujarati for Pramukh
    const generateSMSMessage = (user) => {
        const loginUserName = userName || 'Admin';
        return `નમસ્તે ${user}, ${loginUserName} એ તમને બૂથ પ્રમુખની જવાબદારી સોંપેલી છે.`;
    };

    // --- Translation Dictionary ---
    const t = {
        en: {
            loadingData: "Loading Data...",
            title: "Booth Pramukh",
            addBtn: "Add Booth",
            searchPlaceholder: "Search by Booth Number or Name...",
            boothNo: "Booth No.",
            voters: "Voters",
            boothPramukh: "Booth Pramukh",
            notAssigned: "Not Assigned",
            active: "Active",
            inactive: "Not Active",
            createBtn: "Create Pramukh",
            noResultsPrefix: "No booth found matching",
            noDataAvailable: "No data available",
            modalTitle: "Create Booth Pramukh",
            editModalTitle: "Edit Pramukh",
            nameLabel: "Full Name",
            mobileLabel: "Mobile Number",
            cancelBtn: "Cancel",
            submitBtn: "Create",
            updateBtn: "Update",
            updatingBtn: "Updating...",
            submitting: "Creating...",
            totalBooths: "Total Booths",
            assignedBooths: "Assigned Booths",
            sendWhatsapp: "Send Responsibility in Whatsapp",
            sendSMS: "Send Responsibility in SMS",
            mobileRequired: "Mobile number is required",
            mobileLength: "Mobile number must be 10 digits",
            mobileNumeric: "Mobile number must contain only digits",
            mobileInvalid: "Please enter a valid Indian mobile number (starts with 6,7,8,9)",
            fillAllFields: "Please fill in all fields",
            validMobile: "Please enter a valid 10-digit mobile number",
            deleteConfirm: "Are you sure you want to delete this user?",
            deleteSuccess: "User deleted successfully!",
            deleteFailed: "Failed to delete user.",
            deleteError: "Error deleting user.",
            userIdMissing: "Error: User ID is missing."
        },
        hi: {
            loadingData: "डेटा लोड हो रहा है...",
            title: "बूथ प्रमुख",
            addBtn: "बूथ जोड़ें",
            searchPlaceholder: "बूथ नंबर या नाम द्वारा खोजें...",
            boothNo: "बूथ नं.",
            voters: "मतदाता",
            boothPramukh: "बूथ प्रमुख",
            notAssigned: "आवंटित नहीं",
            active: "सक्रिय",
            inactive: "निष्क्रिय",
            createBtn: "प्रमुख बनाएं",
            noResultsPrefix: "इससे मेल खाने वाला कोई बूथ नहीं मिला",
            noDataAvailable: "कोई डेटा उपलब्ध नहीं है",
            modalTitle: "बूथ प्रमुख बनाएं",
            editModalTitle: "प्रमुख संपादित करें",
            nameLabel: "पूरा नाम",
            mobileLabel: "मोबाइल नंबर",
            cancelBtn: "रद्द करें",
            submitBtn: "बनाएं",
            updateBtn: "अपडेट करें",
            updatingBtn: "अपडेट कर रहा है...",
            submitting: "बना रहा है...",
            totalBooths: "कुल बूथ",
            assignedBooths: "आवंटित बूथ",
            sendWhatsapp: "व्हाट्सएप में जिम्मेदारी भेजें",
            sendSMS: "एसएमएस में जिम्मेदारी भेजें",
            mobileRequired: "मोबाइल नंबर आवश्यक है",
            mobileLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileNumeric: "मोबाइल नंबर में केवल अंक होने चाहिए",
            mobileInvalid: "कृपया एक वैध भारतीय मोबाइल नंबर दर्ज करें (6,7,8,9 से शुरू)",
            fillAllFields: "कृपया सभी फ़ील्ड भरें",
            validMobile: "कृपया 10 अंकों का मोबाइल नंबर दर्ज करें",
            deleteConfirm: "क्या आप वाकई इस उपयोगकर्ता को हटाना चाहते हैं?",
            deleteSuccess: "उपयोगकर्ता सफलतापूर्वक हटा दिया गया!",
            deleteFailed: "उपयोगकर्ता को हटाने में विफल।",
            deleteError: "उपयोगकर्ता को हटाने में त्रुटि।",
            userIdMissing: "त्रुटि: उपयोगकर्ता आईडी गायब है।"
        },
        gu: {
            loadingData: "ડેટા લોડ થઈ રહ્યો છે...",
            title: "બૂથ પ્રમુખ",
            addBtn: "બૂથ ઉમેરો",
            searchPlaceholder: "બૂથ નંબર અથવા નામ દ્વારા શોધો...",
            boothNo: "બૂથ નં.",
            voters: "મતદાર",
            boothPramukh: "બૂથ પ્રમુખ",
            notAssigned: "સોંપેલ નથી",
            active: "Active",
            inactive: "Not Active",
            createBtn: "પ્રમુખ બનાવો",
            noResultsPrefix: "કોઈ બૂથ મળ્યું નથી",
            noDataAvailable: "કોઈ ડેટા ઉપલબ્ધ નથી",
            modalTitle: "બૂથ પ્રમુખ બનાવો",
            editModalTitle: "પ્રમુખ સંપાદિત કરો",
            nameLabel: "પૂરું નામ",
            mobileLabel: "મોબાઇલ નંબર",
            cancelBtn: "રદ કરો",
            submitBtn: "બનાવો",
            updateBtn: "અપડેટ કરો",
            updatingBtn: "અપડેટ કરી રહ્યા છીએ...",
            submitting: "બનાવી રહ્યા છીએ...",
            totalBooths: "કુલ બૂથ",
            assignedBooths: "ફાળવેલ બૂથ",
            sendWhatsapp: "વોટ્સએપમાં જવાબદારી મોકલો",
            sendSMS: "એસએમએસમાં જવાબદારી મોકલો",
            mobileRequired: "મોબાઇલ નંબર જરૂરી છે",
            mobileLength: "મોબાઇલ નંબર 10 અંકનો હોવો જોઈએ",
            mobileNumeric: "મોબાઇલ નંબરમાં માત્ર અંકો હોવા જોઈએ",
            mobileInvalid: "કૃપા કરીને માન્ય ભારતીય મોબાઇલ નંબર દાખલ કરો (6,7,8,9 થી શરૂ)",
            fillAllFields: "કૃપા કરીને બધા ફીલ્ડ ભરો",
            validMobile: "કૃપા કરીને 10 અંકનો માન્ય મોબાઇલ નંબર દાખલ કરો",
            deleteConfirm: "શું તમે ખરેખર આ વપરાશકર્તાને કાઢી નાખવા માંગો છો?",
            deleteSuccess: "વપરાશકર્તા સફળતાપૂર્વક કાઢી નાખવામાં આવ્યો!",
            deleteFailed: "વપરાશકર્તા કાઢી નાખવામાં નિષ્ફળ.",
            deleteError: "વપરાશકર્તા કાઢી નાખવામાં ભૂલ.",
            userIdMissing: "ભૂલ: વપરાશકર્તા ID ગુમ થયેલ છે."
        }
    };

    const txt = t[lang] || t.en;

    // Mobile number validation function
    const validateMobileNumber = (number) => {
        if (!number) {
            return { isValid: false, message: txt.mobileRequired };
        }
        if (!/^\d{10}$/.test(number)) {
            return { isValid: false, message: txt.mobileLength };
        }
        if (!/^\d+$/.test(number)) {
            return { isValid: false, message: txt.mobileNumeric };
        }
        const firstDigit = number.charAt(0);
        if (!['6', '7', '8', '9'].includes(firstDigit)) {
            return { isValid: false, message: txt.mobileInvalid };
        }
        return { isValid: true, message: "" };
    };

    // --- Fetch Data ---
    useEffect(() => {
        if (!appId) {
            navigate("/");
            return;
        }
        fetchUsers();
    }, [appId, navigate]);

    const fetchUsers = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${BASE_URL}/api/dis_booth_pramukh`, {
                app_id: appId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                setUsers(response.data.data.result);
            } else {
                setUsers([]);
            }
        } catch (err) {
            console.error("API Error:", err);
            setUsers([]);
        } finally {
            setLoading(false);
        }
    };

    // Calculate assigned booths count
    const assignedBoothsCount = users.filter(user => user.name !== null && user.name !== "").length;
    const totalBoothsCount = users.length;

    // --- Create Modal Handlers ---
    const handleOpenCreateModal = (boothNo) => {
        setCreateFormData({
            booth_no: boothNo,
            name: '',
            mobile_no: ''
        });
        setCreateMobileError("");
        setIsCreateModalOpen(true);
    };

    const handleCreateInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'mobile_no') {
            const numericValue = value.replace(/[^0-9]/g, '');
            const limitedValue = numericValue.slice(0, 10);
            setCreateFormData(prev => ({ ...prev, [name]: limitedValue }));

            if (createMobileError) setCreateMobileError("");

            if (limitedValue.length === 10) {
                const validation = validateMobileNumber(limitedValue);
                if (!validation.isValid) {
                    setCreateMobileError(validation.message);
                } else {
                    setCreateMobileError("");
                }
            } else if (limitedValue.length > 0 && limitedValue.length < 10) {
                setCreateMobileError(txt.mobileLength);
            }
        } else {
            setCreateFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleCreateSubmit = async (e) => {
        e.preventDefault();
        if (!createFormData.name || !createFormData.mobile_no) {
            alert(txt.fillAllFields);
            return;
        }

        const validation = validateMobileNumber(createFormData.mobile_no);
        if (!validation.isValid) {
            alert(validation.message);
            setCreateMobileError(validation.message);
            return;
        }

        setIsSubmitting(true);
        const payload = {
            app_id: appId,
            name: createFormData.name,
            mobile_no: createFormData.mobile_no,
            user_type: "BP",
            booth_no: createFormData.booth_no,
            booth_list: "",
            create_by: userId || "Admin"
        };

        try {
            const response = await axios.post(`${BASE_URL}/api/insert_user`, payload);
            if (response.data.success) {
                alert("Booth Pramukh created successfully!");
                setIsCreateModalOpen(false);
                setCreateFormData({ booth_no: '', name: '', mobile_no: '' });
                setCreateMobileError("");
                fetchUsers();
            } else {
                alert("Error: " + JSON.stringify(response.data));
            }
        } catch (error) {
            console.error("API Error:", error);
            alert("Failed to create Booth Pramukh.");
        } finally {
            setIsSubmitting(false);
        }
    };

    // --- Edit Handlers ---
    const handleEditClick = (user) => {
        if (user) {
            setEditFormData({
                user_id: user.user_id,
                name: user.name,
                mobile_no: user.mobile_no,
                user_type: user.user_type || 'BP'
            });
            setEditMobileError("");
            setSelectedUser(null); // Close detail popup
            setIsEditModalOpen(true);
        }
    };

    const handleEditInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'mobile_no') {
            const numericValue = value.replace(/[^0-9]/g, '');
            const limitedValue = numericValue.slice(0, 10);
            setEditFormData(prev => ({ ...prev, [name]: limitedValue }));

            if (editMobileError) setEditMobileError("");

            if (limitedValue.length === 10) {
                const validation = validateMobileNumber(limitedValue);
                if (!validation.isValid) {
                    setEditMobileError(validation.message);
                } else {
                    setEditMobileError("");
                }
            } else if (limitedValue.length > 0 && limitedValue.length < 10) {
                setEditMobileError(txt.mobileLength);
            }
        } else {
            setEditFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();

        if (!editFormData.name || !editFormData.mobile_no) {
            alert(txt.fillAllFields);
            return;
        }

        const validation = validateMobileNumber(editFormData.mobile_no);
        if (!validation.isValid) {
            alert(validation.message);
            setEditMobileError(validation.message);
            return;
        }

        setIsEditing(true);

        const payload = {
            user_id: editFormData.user_id,
            app_id: appId,
            name: editFormData.name,
            mobile_no: editFormData.mobile_no,
            user_type: editFormData.user_type,
            booth_no: selectedUser?.booth_no || '',
            booth_list: "",
            create_by: userId || "Admin"
        };

        try {
            const response = await axios.post(`${BASE_URL}/api/update_user`, payload);
            if (response.data.success && response.data.data && response.data.data.Success == "1") {
                alert("Updated successfully!");
                setIsEditModalOpen(false);
                setEditMobileError("");
                fetchUsers();
            } else {
                alert(response.data.data?.Message || "Failed to update.");
            }
        } catch (error) {
            console.error("Axios Error:", error);
            alert(error.response?.data?.error || "Error updating.");
        } finally {
            setIsEditing(false);
        }
    };

    // --- Delete Handler ---
    const handleDeleteUser = async (id) => {
        if (!id) {
            alert(txt.userIdMissing);
            return;
        }

        if (window.confirm(txt.deleteConfirm)) {
            try {
                const response = await axios.post(`${BASE_URL}/api/dlt_user`, {
                    app_id: appId,
                    user_id: id,
                    delete_by: userId || "Admin"
                });

                if (response.data.success || response.data.Success == "1" || (response.data.data && response.data.data.Success == "1")) {
                    alert(txt.deleteSuccess);
                    setSelectedUser(null);
                    fetchUsers();
                } else {
                    alert(response.data.message || response.data.Message || response.data.data?.Message || txt.deleteFailed);
                }
            } catch (error) {
                console.error("Delete Error:", error);
                alert(txt.deleteError);
            }
        }
    };

    // --- Filter Logic ---
    const filteredUsers = users.filter(user => {
        if (!searchTerm) return true;
        const searchLower = searchTerm.toLowerCase().trim();
        const boothNo = user.booth_no?.toString().toLowerCase() || "";
        const name = user.name?.toLowerCase() || "";
        return boothNo.includes(searchLower) || name.includes(searchLower);
    });

    return (
        <>
            {/* Main content is wrapped separately from the modal */}
            <div className={`app-container dashboard-page pb-5 ${isCreateModalOpen || selectedUser || isEditModalOpen ? 'blur-background' : ''}`}>

                <Header title={txt.title} />

                <div className="content-container container-fluid p-3 p-md-4 mx-auto">

                    {/* --- Search Bar and Stats Row --- */}
                    <div className="search-stats-row mb-4 slide-up-element" style={{ animationDelay: '0.05s' }}>
                        {/* UPDATED: Professional Filter Container from MyGroup page */}
                        <div className="filter-container-modern">
                            <div className="search-wrapper-modern">
                                <svg className="search-icon-modern" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                                <input
                                    className="search-input-modern"
                                    type="text"
                                    placeholder={txt.searchPlaceholder}
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                        </div>

                        {/* Stats Cards */}
                        <div className="stats-container">
                            <div className="stat-card total-card">
                                <div className="stat-icon">🏢</div>
                                <div className="stat-info">
                                    <span className="stat-label">{txt.totalBooths}</span>
                                    <span className="stat-value">{totalBoothsCount}</span>
                                </div>
                            </div>
                            <div className="stat-card assigned-card">
                                <div className="stat-icon">✅</div>
                                <div className="stat-info">
                                    <span className="stat-label">{txt.assignedBooths}</span>
                                    <span className="stat-value">{assignedBoothsCount}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Loading State */}
                    {loading ? (
                        <div className="text-center p-5">
                            <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-3 text-muted font-weight-bold">{txt.loadingData}</p>
                        </div>
                    ) : (
                        /* User Grid */
                        <div className="row g-4 slide-up-element" style={{ animationDelay: '0.1s' }}>
                            {filteredUsers.length > 0 ? (
                                filteredUsers.map((user, index) => {
                                    const isAssigned = user.name !== null && user.name !== "";
                                    const isActive = user.last_login !== null && user.last_login !== "";

                                    return (
                                        <div className="col-12 col-sm-6 col-lg-4 col-xl-3" key={index} onClick={() => { if (isAssigned) navigate('/booth_pramukh_detail_with_voters', { state: { selectedBoothNo: user.booth_no } }) }}>
                                            <div className="bp-card">

                                                {/* Top Light Green Section */}
                                                <div className="bp-card-header">
                                                    <div
                                                        className="bp-avatar"
                                                        onClick={(e) => {
                                                            if (isAssigned) {
                                                                e.stopPropagation();
                                                                setSelectedUser(user);
                                                            }
                                                        }}
                                                        style={{ cursor: isAssigned ? 'pointer' : 'default' }}
                                                    >
                                                        {user.photo_path ? (
                                                            <img src={user.photo_path} alt={user.name} />
                                                        ) : (
                                                            <svg width="32" height="32" viewBox="0 0 24 24" fill="white">
                                                                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                                                            </svg>
                                                        )}
                                                    </div>
                                                    <div className="bp-header-info">
                                                        <h3 className="bp-booth-no">{txt.boothNo} {user.booth_no}</h3>
                                                        <p className="bp-voter-count">{txt.voters} : {user.total_voter || 0}</p>
                                                    </div>
                                                </div>

                                                {/* Middle Details Section */}
                                                <div className="bp-card-body">
                                                    <span className="bp-label">{txt.boothPramukh}</span>
                                                    <h4 className={`bp-name ${!isAssigned ? 'text-muted' : ''}`}>
                                                        {isAssigned ? user.name : txt.notAssigned}
                                                    </h4>

                                                    {isAssigned ? (
                                                        <div className={`bp-status-pill ${isActive ? 'active' : 'inactive'}`}>
                                                            {isActive ? txt.active : txt.inactive}
                                                        </div>
                                                    ) : (
                                                        <div className="bp-status-pill unassigned" style={{ visibility: 'hidden' }}>Placeholder</div>
                                                    )}
                                                </div>

                                                {/* Bottom Actions Section */}
                                                <div className="bp-card-footer">
                                                    {isAssigned ? (
                                                        <>
                                                            <button className="bp-action-btn text-primary" onClick={(e) => { e.stopPropagation(); window.open(`tel:${user.mobile_no}`); }}>
                                                                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                                                            </button>
                                                            <button
                                                                className="bp-action-btn text-success"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    window.open(`https://wa.me/91${user.mobile_no}`, '_blank');
                                                                }}
                                                            >
                                                                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                                                                </svg>
                                                            </button>
                                                            <button 
                                                                className="bp-action-btn text-warning" 
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setSelectedUser(user);
                                                                }}
                                                            >
                                                                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <button className="bp-create-btn" onClick={(e) => { e.stopPropagation(); handleOpenCreateModal(user.booth_no); }}>
                                                            {txt.createBtn}
                                                        </button>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="col-12">
                                    <div className="text-center text-muted p-5 bg-white rounded shadow-sm border">
                                        <div style={{ fontSize: '40px', marginBottom: '16px' }}>📭</div>
                                        <h4>{searchTerm ? `${txt.noResultsPrefix} "${searchTerm}"` : txt.noDataAvailable}</h4>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* Edit Modal */}
            {isEditModalOpen && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal-box slide-up-element" style={{ animationDuration: '0.2s', maxWidth: '400px' }}>
                        <div className="custom-modal-header">
                            <h2>{txt.editModalTitle}</h2>
                            <button className="custom-close-btn" onClick={() => setIsEditModalOpen(false)}>
                                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                            </button>
                        </div>
                        <form onSubmit={handleUpdateSubmit}>
                            <div className="custom-form-body">
                                <div className="custom-input-group">
                                    <label>{txt.boothNo}</label>
                                    <input type="text" value={selectedUser?.booth_no || ''} disabled style={{ background: '#f3f4f6', cursor: 'not-allowed' }} />
                                </div>
                                <div className="custom-input-group">
                                    <label>{txt.nameLabel}</label>
                                    <input type="text" name="name" value={editFormData.name} onChange={handleEditInputChange} required />
                                </div>
                                <div className="custom-input-group">
                                    <label>{txt.mobileLabel}</label>
                                    <input
                                        type="text"
                                        name="mobile_no"
                                        value={editFormData.mobile_no}
                                        onChange={handleEditInputChange}
                                        maxLength="10"
                                        required
                                        style={{
                                            border: editMobileError ? '1px solid #ef4444' : '1px solid #cbd5e1'
                                        }}
                                    />
                                    {editMobileError && (
                                        <div style={{ fontSize: '12px', color: '#ef4444', marginTop: '4px' }}>
                                            {editMobileError}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="custom-modal-footer">
                                <button type="button" className="btn-secondary" onClick={() => setIsEditModalOpen(false)}>{txt.cancelBtn}</button>
                                <button type="submit" className="btn-primary" disabled={isEditing} style={{ background: '#f59e0b' }}>
                                    {isEditing ? txt.updatingBtn : txt.updateBtn}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Profile Detail Modal - Same design as reference page */}
            {selectedUser && (
                <div className="custom-modal-overlay" onClick={() => setSelectedUser(null)} style={{ zIndex: 10001 }}>
                    <div className="profile-detail-container" onClick={(e) => e.stopPropagation()}>
                        <button className="profile-close-btn" onClick={() => setSelectedUser(null)}>
                            <svg width="24" height="24" fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                        </button>
                        <div className="profile-detail-card">
                            <div className="profile-avatar-wrapper">
                                <div className="profile-avatar-bg">
                                    <img src={selectedUser.photo_path ? selectedUser.photo_path : `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedUser.name)}&background=e5e5e5&color=a3a3a3`} alt={selectedUser.name} />
                                </div>
                            </div>
                            <div className="profile-content">
                                <h2 className="profile-name">{selectedUser.name}</h2>
                                <p className="profile-mobile">{selectedUser.mobile_no}</p>
                                <div className="profile-big-btns">
                                    <a href={`https://wa.me/91${selectedUser.mobile_no}?text=${encodeURIComponent(generateWhatsAppMessage(selectedUser.name))}`} target="_blank" rel="noreferrer" className="btn-resp btn-wa">
                                        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
                                        {txt.sendWhatsapp}
                                    </a>
                                    <a href={`sms:${selectedUser.mobile_no}?body=${encodeURIComponent(generateSMSMessage(selectedUser.name))}`} className="btn-resp btn-sms-big">
                                        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2 2z"></path></svg>
                                        {txt.sendSMS}
                                    </a>
                                </div>
                            </div>
                            <div className="profile-bottom-bar">
                                <a href={`tel:${selectedUser.mobile_no}`} className="btm-icon-wrapper">
                                    <div className="icon-transparent" style={{ color: '#0ea5e9' }}>
                                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" /></svg>
                                    </div>
                                </a>
                                <div className="divider"></div>
                                <a href={`https://wa.me/91${selectedUser.mobile_no}`} target="_blank" rel="noreferrer" className="btm-icon-wrapper">
                                    <div className="icon-transparent" style={{ color: '#22c55e' }}>
                                        <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
                                    </div>
                                </a>
                                <div className="divider"></div>
                                <a href={`sms:${selectedUser.mobile_no}`} className="btm-icon-wrapper">
                                    <div className="icon-transparent" style={{ color: '#3b82f6', position: 'relative' }}>
                                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 10H6v-2h12v2zm0-3H6V7h12v2z" /></svg>
                                        <span style={{ position: 'absolute', fontSize: '7px', color: 'white', fontWeight: 'bold', marginTop: '-2px' }}></span>
                                    </div>
                                </a>
                                <div className="divider"></div>
                                {/* Edit Button - Opens Edit Modal */}
                                <button 
                                    className="btm-icon-wrapper" 
                                    onClick={() => navigate('/booth_pramukh_detail_with_voters', { state: { selectedBoothNo: selectedUser.booth_no } })} 
                                    style={{ background: 'none', border: 'none', padding: 0 }}
                                >
                                    <div className="icon-transparent" style={{ color: '#f59e0b' }}>
                                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" /></svg>
                                    </div>
                                </button>
                                <div className="divider"></div>
                                {/* Delete Button */}
                                <button 
                                    className="btm-icon-wrapper" 
                                    onClick={() => navigate('/booth_pramukh_detail_with_voters', { state: { selectedBoothNo: selectedUser.booth_no } })} 
                                    style={{ background: 'none', border: 'none', padding: 0 }}
                                >
                                    <div className="icon-transparent" style={{ color: '#ef4444' }}>
                                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" /></svg>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Create Modal */}
            {isCreateModalOpen && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal-box slide-up-element" style={{ animationDuration: '0.2s' }}>
                        <div className="custom-modal-header">
                            <h2>{txt.modalTitle}</h2>
                            <button className="custom-close-btn" onClick={() => setIsCreateModalOpen(false)}>
                                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                            </button>
                        </div>
                        <form onSubmit={handleCreateSubmit}>
                            <div className="custom-form-body">
                                <div className="custom-input-group">
                                    <label>{txt.boothNo}</label>
                                    <input type="text" value={createFormData.booth_no} disabled style={{ background: '#f3f4f6', cursor: 'not-allowed' }} />
                                </div>
                                <div className="custom-input-group">
                                    <label>{txt.nameLabel}</label>
                                    <input type="text" name="name" value={createFormData.name} onChange={handleCreateInputChange} required />
                                </div>
                                <div className="custom-input-group">
                                    <label>{txt.mobileLabel}</label>
                                    <input
                                        type="text"
                                        name="mobile_no"
                                        value={createFormData.mobile_no}
                                        onChange={handleCreateInputChange}
                                        maxLength="10"
                                        required
                                        style={{
                                            border: createMobileError ? '1px solid #ef4444' : '1px solid #cbd5e1'
                                        }}
                                    />
                                    {createMobileError && (
                                        <div style={{ fontSize: '12px', color: '#ef4444', marginTop: '4px' }}>
                                            {createMobileError}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="custom-modal-footer">
                                <button type="button" className="btn-secondary" onClick={() => setIsCreateModalOpen(false)}>{txt.cancelBtn}</button>
                                <button type="submit" className="btn-primary" disabled={isSubmitting}>
                                    {isSubmitting ? txt.submitting : txt.submitBtn}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            <style jsx>{`
                /* --- BLUR EFFECT --- */
                .blur-background { filter: blur(4px); pointer-events: none; transition: filter 0.3s ease; }

                .header-container-white {
                    background-color: #ffffff;
                    padding: 15px 32px;
                    border-bottom: 1px solid #e2e8f0;
                    margin: -24px 0px 10px 0px; 
                    box-shadow: 0 2px 4px rgba(0,0,0,0.02);
                    position: sticky;
                    top: 0;
                    z-index: 10;
                }
                .header-wrapper { background: white; padding: 0px 24px; position: sticky; top: 0; z-index: 50; }
                
                /* --- UPDATED: PROFESSIONAL FILTER CONTAINER FROM MYGROUP --- */
                .filter-container-modern {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    flex: 2;
                    min-width: 250px;
                }
                .search-wrapper-modern {
                    position: relative;
                    width: 100%;
                    max-width: 450px;
                }
                .search-icon-modern {
                    position: absolute;
                    left: 16px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #94a3b8;
                    width: 18px;
                    height: 18px;
                }
                .search-input-modern {
                    width: 100%;
                    padding: 12px 16px 12px 46px;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    font-size: 14px;
                    color: #1e293b;
                    outline: none;
                    transition: all 0.2s ease;
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
                    background: #ffffff;
                }
                .search-input-modern:focus {
                    border-color: #2563eb;
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
                }

                /* Search and Stats Row */
                .search-stats-row {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 20px;
                    flex-wrap: wrap;
                }

                /* Stats Cards */
                .stats-container {
                    display: flex;
                    gap: 15px;
                    flex-shrink: 0;
                }
                
                .stat-card {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    background: white;
                    padding: 10px 20px;
                    border-radius: 14px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
                    border: 1px solid #e2e8f0;
                    transition: all 0.2s ease;
                }
                
                .stat-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.1);
                }
                
                .stat-card.total-card {
                    border-left: 4px solid #3b82f6;
                }
                
                .stat-card.assigned-card {
                    border-left: 4px solid #10b981;
                }
                
                .stat-icon {
                    font-size: 28px;
                }
                
                .stat-info {
                    display: flex;
                    flex-direction: column;
                }
                
                .stat-label {
                    font-size: 11px;
                    font-weight: 600;
                    color: #64748b;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }
                
                .stat-value {
                    font-size: 22px;
                    font-weight: 800;
                    color: #0f172a;
                    line-height: 1.2;
                }
                
                .stat-card.total-card .stat-value {
                    color: #3b82f6;
                }
                
                .stat-card.assigned-card .stat-value {
                    color: #10b981;
                }

                /* --- Card Styling based on User Image --- */
                .bp-card {
                    background: #ffffff;
                    border-radius: 12px;
                    border: 1px solid #e2e8f0;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    transition: transform 0.2s ease, box-shadow 0.2s ease;
                    height: 100%;
                    cursor: pointer;
                }
                .bp-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 12px 20px rgba(0,0,0,0.08);
                }

                /* Light Green Top Header */
                .bp-card-header {
                    background-color: #dcfce7; /* Light Green */
                    padding: 16px 20px;
                    display: flex;
                    align-items: center;
                    gap: 16px;
                }
                .bp-avatar {
                    width: 56px;
                    height: 56px;
                    border-radius: 50%;
                    background: #a1a1aa; /* Gray placeholder background */
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    overflow: hidden;
                    flex-shrink: 0;
                    transition: transform 0.2s;
                }
                .bp-avatar:hover {
                    transform: scale(1.05);
                }
                .bp-avatar img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                .bp-header-info {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                }
                .bp-booth-no {
                    margin: 0;
                    font-size: 18px;
                    font-weight: 800;
                    color: #1c1917;
                }
                .bp-voter-count {
                    margin: 0;
                    font-size: 15px;
                    font-weight: 700;
                    color: #16a34a; /* Green text */
                }

                /* Body / Name Section */
                .bp-card-body {
                    padding: 24px 20px;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    flex-grow: 1;
                }
                .bp-label {
                    font-size: 13px;
                    font-weight: 700;
                    color: #64748b;
                    margin-bottom: 6px;
                }
                .bp-name {
                    font-size: 20px;
                    font-weight: 800;
                    color: #0f172a;
                    margin: 0 0 16px 0;
                    line-height: 1.2;
                }
                
                /* Status Pills */
                .bp-status-pill {
                    padding: 8px 24px;
                    border-radius: 30px;
                    font-size: 14px;
                    font-weight: 700;
                    display: inline-block;
                }
                .bp-status-pill.active {
                    background-color: #dcfce7; /* Vibrant Green from image */
                    color: #166534;
                }
                .bp-status-pill.inactive { 
                    background-color: #fee2e2; /* Red */
                    color: #991b1b;
                }

                /* Footer Actions */
                .bp-card-footer {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    padding: 16px;
                    border-top: 1px solid #e2e8f0;
                    background: #ffffff;
                }
                .bp-action-btn {
                    background: none;
                    border: none;
                    cursor: pointer;
                    padding: 8px;
                    border-radius: 50%;
                    transition: background 0.2s;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .bp-action-btn:hover:not(:disabled) {
                    background: #f1f5f9;
                }
                .bp-create-btn {
                    width: 100%;
                    padding: 10px;
                    background: #991b1b;
                    color: white;
                    border: none;
                    border-radius: 8px;
                    font-weight: 600;
                    font-size: 14px;
                    cursor: pointer;
                    transition: 0.2s;
                }
                .bp-create-btn:hover { background: #2563eb; }

                /* --- MODAL CSS --- */
                .custom-modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(15, 23, 42, 0.75); backdrop-filter: blur(4px); display: flex; align-items: center; justify-content: center; z-index: 10000; padding: 20px; box-sizing: border-box; }
                .custom-modal-box { background: white; border-radius: 16px; width: 100%; max-width: 420px; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); overflow: hidden; }
                .custom-modal-header { padding: 20px 24px; border-bottom: 1px solid #f1f5f9; display: flex; justify-content: space-between; align-items: center; }
                .custom-modal-header h2 { margin: 0; font-size: 1.25rem; color: #0f172a; font-weight: 700; }
                .custom-close-btn { background: none; border: none; color: #94a3b8; cursor: pointer; }
                .custom-form-body { padding: 24px; display: flex; flex-direction: column; gap: 16px; }
                .custom-input-group { display: flex; flex-direction: column; gap: 6px; }
                .custom-input-group label { font-size: 13px; font-weight: 600; color: #475569; }
                .custom-input-group input { padding: 12px 16px; border: 1px solid #cbd5e1; border-radius: 8px; font-size: 14px; outline: none; }
                .custom-modal-footer { padding: 16px 24px; background: #f8fafc; border-top: 1px solid #f1f5f9; display: flex; justify-content: flex-end; gap: 12px; }
                .btn-secondary { padding: 10px 16px; border: 1px solid #cbd5e1; background: white; color: #475569; border-radius: 8px; font-weight: 600; cursor: pointer; }
                .btn-primary { padding: 10px 20px; border: none; background: #2563eb; color: white; border-radius: 8px; font-weight: 600; cursor: pointer; }

                /* --- PROFILE DETAIL MODAL CSS --- */
                .profile-detail-container { position: relative; width: 100%; max-width: 380px; margin-top: 50px; }
                .profile-close-btn { position: absolute; top: -40px; right: -10px; background: none; border: none; cursor: pointer; padding: 5px; z-index: 10; color: white; }
                .profile-detail-card { background: white; border-radius: 20px; display: flex; flex-direction: column; overflow: visible; box-shadow: 0 15px 35px rgba(0,0,0,0.2); }
                .profile-avatar-wrapper { display: flex; justify-content: center; margin-top: -55px; }
                .profile-avatar-bg { width: 110px; height: 110px; background: white; border-radius: 50%; padding: 6px; cursor: pointer; position: relative; overflow: hidden; }
                .profile-avatar-bg img { width: 100%; height: 100%; border-radius: 50%; object-fit: cover; }
                .profile-content { padding: 15px 24px 25px 24px; text-align: center; }
                .profile-name { font-size: 22px; font-weight: 800; color: #111827; text-transform: uppercase; margin: 0; }
                .profile-mobile { font-size: 16px; color: #374151; letter-spacing: 0.5px; font-weight: 500; margin: 8px 0; }
                .profile-big-btns { display: flex; flex-direction: column; gap: 12px; }
                .btn-resp {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                    width: 100%;
                    padding: 14px;
                    border-radius: 50px;
                    color: white;
                    font-weight: 600;
                    text-decoration: none;
                    font-size: 15px;
                    transition: transform 0.2s, box-shadow 0.2s;
                    border: none;
                    box-sizing: border-box;
                }
                .btn-resp:hover { transform: translateY(-2px); box-shadow: 0 4px 10px rgba(0,0,0,0.15); color: white; }
                .btn-wa { background-color: #4ade80; }
                .btn-sms-big { background-color: #f59e0b; }
                .profile-bottom-bar { background-color: #213555; border-radius: 0 0 20px 20px; display: flex; justify-content: space-evenly; align-items: center; padding: 12px 0;}
                .divider { width: 1px; height: 24px; background-color: rgba(255, 255, 255, 0.3); }
                .btm-icon-wrapper { background: none; border: none; padding: 0; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: transform 0.2s; text-decoration: none; }
                .btm-icon-wrapper:hover { transform: scale(1.1); }
                .icon-transparent { display: flex; align-items: center; justify-content: center; }

                /* Responsive */
                @media (max-width: 768px) {
                    .search-stats-row {
                        flex-direction: row;
                        flex-wrap: nowrap;
                        gap: 8px;
                        align-items: center;
                    }
                    .filter-container-modern {
                        flex: 1;
                        min-width: 0;
                    }
                    .search-wrapper-modern {
                        max-width: 100%;
                    }
                    .search-input-modern {
                        padding: 10px 30px 10px 38px;
                        font-size: 13px;
                    }
                    .search-icon-modern {
                        width: 16px;
                        height: 16px;
                        left: 12px;
                    }
                    .stats-container {
                        gap: 6px;
                        flex-shrink: 0;
                    }
                    .stat-card {
                        padding: 6px 12px;
                        gap: 6px;
                    }
                    .stat-icon {
                        font-size: 18px;
                    }
                    .stat-value {
                        font-size: 16px;
                    }
                    .stat-label {
                        font-size: 9px;
                    }
                }

                @media (max-width: 480px) {
                    .filter-container-modern {
                        flex: 1;
                        min-width: 0;
                    }
                    .search-input-modern {
                        padding: 10px 30px 10px 38px;
                        font-size: 13px;
                    }
                    .stat-card {
                        padding: 4px 10px;
                    }
                    .stat-icon {
                        font-size: 16px;
                    }
                    .stat-value {
                        font-size: 14px;
                    }
                    .stat-label {
                        font-size: 8px;
                    }
                    .stats-container {
                        gap: 4px;
                    }
                    .search-input-modern { font-size: 12px; padding: 8px 24px 8px 32px; }
                    .search-icon-modern { width: 14px; height: 14px; left: 10px; }
                }

                /* Animations */
                .slide-up-element { animation: slideUp 0.4s ease forwards; opacity: 0; }
                @keyframes slideUp { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>
        </>
    );
};

export default BoothPramukh;